import { createBrowserRouter, Navigate } from 'react-router-dom';
import AdminUsersPage from '../pages/Admin/AdminUsersPage.tsx';
import AdminAutoparksPage from '../pages/Admin/AdminAutoparksPage.tsx';
import AdminWaybillsPage from '../pages/Admin/AdminWaybillsPage.tsx';
import CreateUserPage from '../pages/CreateUserPage/CreateUserPage.tsx';
import AutoparkDetailsPage from '../pages/AutoparkDetailsPage/AutoparkDetailsPage.tsx';
import Medic from '../pages/Medic/Medic.tsx';
import Tech from '../pages/Tech/Tech.tsx';
import Login from '../components/Login/Login.tsx';
import ErrorPage from '../components/ErrorPage/ErrorPage.tsx';
import ProtectedRoute from './ProtectRoute.tsx';
import AppLayout from '../pages/AppLayout.tsx';

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <ProtectedRoute
        component={Login}
        allowedRoles={undefined}
        roleRedirects={{
          medic: '/account/medic',
          technik: '/account/technik',
          admin: '/account/admin/users',
          autopark_employee: '/account/autopark_employee',
        }}
      />
    ),
    errorElement: <ErrorPage />,
  },
  // {
  //   path: '*',
  //   element: <ErrorPage />,
  // },
  {
    path: '/account',
    element: <AppLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'admin/users',
        element: <ProtectedRoute component={AdminUsersPage} allowedRoles={['admin']} />,
      },
      {
        path: 'admin/autoparks',
        element: <ProtectedRoute component={AdminAutoparksPage} allowedRoles={['admin']} />,
      },
      {
        path: 'admin/waybills',
        element: <ProtectedRoute component={AdminWaybillsPage} allowedRoles={['admin']} />,
      },
      {
        path: 'autopark_employee',
        element: <ProtectedRoute component={AutoparkDetailsPage} allowedRoles={['autopark_employee']} />,
      },
      {
        path: 'medic',
        element: (
          <ProtectedRoute
            component={Medic}
            allowedRoles={['medic']}
            roleRedirects={{
              medic: '/account/medic',
              technik: '/account/technik',
              admin: '/account/admin',
            }}
          />
        ),
      },
      {
        path: 'technik',
        element: (
          <ProtectedRoute
            component={Tech}
            allowedRoles={['technik']}
            roleRedirects={{
              medic: '/account/medic',
              technik: '/account/technik',
              admin: '/account/admin',
            }}
          />
        ),
      },
      {
        path: 'create-user',
        element: <ProtectedRoute component={CreateUserPage} allowedRoles={['admin']} />,
      },
      {
        path: 'autopark/:id',
        element: <ProtectedRoute component={AutoparkDetailsPage} allowedRoles={['admin', 'autopark_employee']} />,
      },
    ],
  },
]);
